import React from 'react';
import PlayerListing from './../onboarding/PlayerListing'
import PitchViewManageTeam from './PitchView-ManageTeam';
import AdBottom from '../AdBottom';
import OutsideNotifier from '../../OutsideNotifier'
import PlayerRecomendationPopUp from './../onboarding/filters/PlayerRecomendationPopUp'
import PlayerRecomendationPopUpMob from './../onboarding/filters/PlayerRecomendationPopUpMob'
import config from '../../config';

const MainPitchManageTeam = (props) => {
    return <React.Fragment>
        <div className={"si-wrap si-flexBox " + (props.manageTeamMode === config.modes["transfer"] ? "" : "si-pl-wrp")}>
            {props.toShowList ? <PlayerListing /> : null}
            {props.showPlayerRecomendationPopUp ? <OutsideNotifier handler={() => props.showHidePlayerRecomendationPopUp(false)}><PlayerRecomendationPopUp setPlayerRecomendationFirstTimeFalse={props.setPlayerRecomendationFirstTimeFalse} showHidePlayerRecomendationPopUp={props.showHidePlayerRecomendationPopUp}></PlayerRecomendationPopUp> </OutsideNotifier> : null}

            {props.showPlayerrecomendationPopupMobile ? <OutsideNotifier handler={() => props.showHidePlayerRecomendationPopUpMob(false)}><PlayerRecomendationPopUpMob showHidePlayerRecomendationPopUpMob={props.showHidePlayerRecomendationPopUpMob}></PlayerRecomendationPopUpMob> </OutsideNotifier> : null}

            <PitchViewManageTeam {...props} />
        </div>
        <AdBottom />
        <div className="si-bottom-bg" />
    </React.Fragment>
};
export default MainPitchManageTeam;


// WEBPACK FOOTER //
// ./src/components/manage-team/MainPitch-ManageTeam.js